module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "dedication"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('strong', [_c('em', [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EDICATION")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("To our daughters, Kindra and Kerith,"), _c('br'), _vm._v("who are coincidentally both back in school"), _c('br'), _vm._v("and rebooting their own lives.")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("May the world you inherit be as rich in wonder and"), _c('br'), _vm._v("opportunity as the world into which your parents were born.")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("Thank you both for being such wonderful, caring,"), _c('br'), _vm._v("and honorable human beings, so dedicated to"), _c('br'), _vm._v("healing the world one person at a time.")]), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d6dd37b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedication.vue
// module id = 72
// module chunks = 0